import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Draggable, Droppable } from "react-drag-and-drop";
import { onLeave, openAddTaskModal, openTaskDetailModel } from "../../actions";
import Avatar1 from "../../assets/images/xs/avatar1.jpg";
import mainHelper, { apiCall, getEmployes } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import AddTaskModal from "../../components/AddTaskModal";
import UserComments from "../../components/UserComments";
import TaskDetailModel from "../../components/TaskDetailModel";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";

class AppTaskbar extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchTasks();
  }

  state = {
    tasks: {
      planned: [],
      inProgress: [],
      completed: []
    },
    isLoad: false,
    taskStatusLoading: false,
    employees: null,
    taskDetailData: [],
    isAddTaskModalOpen: false,
    collapsedTaskId: ''
  };

  fetchTasks = async () => {
    try {
      const response = await apiCall('business/tasks', 'get', null);
      const employees = await getEmployes();
      const groupedTasks = response.reduce((acc, task) => {
        if (!acc[task.status]) {
          acc[task.status] = [];
        }
        acc[task.status].push(task);
        return acc;
      }, {});
      this.setState({ tasks: groupedTasks, employees: employees }, () => {
        this.setState({ isLoad: true })
      });
    } catch (error) {
      this.setState({
        tasks: {
          planned: [],
          inProgress: [],
          completed: []
        }
      });
      this.setState({ isLoad: true })
      console.error("There was an error fetching the tasks!", error);
    }
  };

  updateTaskStatus = async (taskId, status) => {
    this.setState({ taskStatusLoading: true });
    try {
      const response = await apiCall(`business/tasks/update/status/${taskId}`, 'post', { status });
      await this.fetchTasks()
      mainHelper.toastMessage('success', response.message)
      this.setState({ taskStatusLoading: false });
    } catch (error) {
      this.setState({ taskStatusLoading: false });
    }
  };
  showComments = (taskID) => {
    var id = "collapse" + taskID;
    this.setState(prevState => ({
      collapsedTaskId: prevState.collapsedTaskId === taskID ? null : taskID
    }));

    var details = document.getElementById(id);
    if (details.classList.contains("show")) {
      details.classList.remove("show");
    } else {
      details.classList.add("show");
    }
  }
  showTaskDetailModel = (taskID, assignedUsers, title, description) => {
    this.props.openTaskDetailModel({
      assignedUsers: assignedUsers,
      taskID: taskID,
      title: title,
      description: description,
      employees: this.state.employees,
    })
  }

  onDrop = (data, status) => {
    const taskId = data.task;
    this.updateTaskStatus(taskId, status);
  };
  openTaskModal = (status) => {
    this.props.openAddTaskModal({
      status: status,
    })
  };
  handleDelete = async (taskID) => {
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall('business/tasks/delete/' + taskID, 'delete');
          await this.fetchTasks();
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'Silindi!',
          'Görev başarıyla silindi.',
          'success'
        );
      } else {
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  }
  renderTask = (task) => {
    let statusClass = '';
    let statusColor = '';
    if (task.status === 'planned') {
      statusClass = 'dd-handle';
      statusColor = '#f0f0f0';
    } else if (task.status === 'inProgress') {
      statusClass = 'dd-handle1';
      statusColor = '#ffce4b';
    } else if (task.status === 'completed') {
      statusClass = 'dd-handle2';
      statusColor = '#86c541';
    }
    return (
      <Draggable type="task" data={task.id} key={task.id}>
        <li className="dd-item">
          <div className={statusClass}>#{task.id}</div>
          <div className="dd-content p-15">
            <h5>{task.title}</h5>
            <p>{task.description}</p>
            <ul className="list-unstyled team-info m-t-20 m-b-20">
              <li className="m-r-15"><small className="text-muted">İlgili kişiler:</small></li>
              {task.assigned_users.map(user => (
                <li key={user.id}><img src={user.profile_photo_url || Avatar1} title={user.name} alt={user.name} />
                </li>
              ))}
            </ul>
            <hr />
            <div className="action">
              <button type="button" className="btn btn-sm btn-outline-secondary" title="Düzenle"
                onClick={() => this.showTaskDetailModel(task.id, task.assigned_users, task.title, task.description)}>
                <i className="icon-note"></i>
              </button>
              <button type="button" className="btn btn-sm btn-outline-info"
                title="Yorumlar"
                data-toggle="collapse"
                aria-expanded="false"
                aria-controls="collapseExample"
                onClick={() => this.showComments(task.id)}>
                <i className="icon-bubbles"></i>
              </button>

              <button onClick={() => this.handleDelete(task.id)} type="button" data-type="confirm"
                className="btn btn-sm btn-outline-danger float-right js-sweetalert" title="Sil">
                <i className="icon-trash"></i>
              </button>
            </div>
          </div>

          <div className={`collapse ${this.state.collapsedTaskId === task.id ? 'show' : ''}`} id={'collapse' + task.id}>
            {this.state.collapsedTaskId === task.id && (
              <UserComments
                comments={task.comments}
                status={statusColor}
                taskID={task.id}
                fetchTasks={this.fetchTasks}>
              </UserComments>
            )}
          </div>
        </li>
      </Draggable>
    );
  };

  render() {
    const { tasks, isLoad } = this.state;
    const { isAddTaskModalOpen } = this.props;
    const statusNames = {
      'Planned': 'Planlanmış',
      'InProgress': 'İşlemde',
      'Completed': 'Tamamlandı',
    }
    return (
      <div style={{ flex: 1 }}>
        <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'none' : 'block' }}>
          <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="m-t-30">
              <img src={require('../../assets/images/logo-white.png')} width="150" alt="Servicezone" />
            </div>
            <p>Yükleniyor</p>
            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
          </div>
        </div>
        <div className="page-loader-wrapper" style={{ display: !this.state.taskStatusLoading ? 'none' : 'block', background: 'rgba(128, 128, 128, 0.5)' }}>
          <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="m-t-30">
              <img src={require('../../assets/images/logo-white.png')} width="150" alt="Servicezone" />
            </div>
            <p>Lütfen bekleyin...</p>
            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />
          </div>
        </div>
        <div className="ng-star-inserted">
          <div className="container-fluid">
            <PageHeader HeaderText="İş Akış Panosu" Breadcrumb={[{ name: "Uygulamalar" }, { name: "İş Akış Panosu" }]} />
            <div className="row clearfix">
              {['planned', 'inProgress', 'completed'].map((status, index) => (
                <div key={status} className="col-lg-4 col-md-12">
                  <div className="card planned_task">
                    <div className="header">
                      <h2>{statusNames[status.charAt(0).toUpperCase() + status.slice(1)]}</h2>
                      <ul className="header-dropdown">
                        <li>
                          <button onClick={() => this.openTaskModal(status)} style={{ border: "none", background: "none" }}>
                            <i className="icon-plus"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div className="body taskboard">
                      <div className="dd" data-plugin="nestable">
                        <Droppable key={index} onDrop={(data) => this.onDrop(data, status)} types={["task"]}>
                          <ul>
                            {tasks[status] && tasks[status].map(this.renderTask)}
                          </ul>
                          {tasks[status] && tasks[status].length === 0 ? (
                            <div className="dd-empty"></div>
                          ) : (
                            <div className="p-10"></div>
                          )}
                        </Droppable>
                      </div>
                    </div>
                    {this.props.isTaskDetailModalOpen ? (
                      <TaskDetailModel fetchTasks={this.fetchTasks}></TaskDetailModel>
                    ) : ""}
                    {isLoad ? (
                      <AddTaskModal
                        isAddTaskModalOpen={isAddTaskModalOpen}
                        fetchTasks={this.fetchTasks}
                        employees={this.state.employees}
                      ></AddTaskModal>
                    ) : ""}

                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
  isTaskDetailModalOpen: mailInboxReducer.isTaskDetailModalOpen,
  isModalOpen: mailInboxReducer.isAddTaskModalOpen,
  taskModalData: mailInboxReducer.taskModalData,
  addTaskModalData: mailInboxReducer.addTaskModalData,
  userCommentModelData: mailInboxReducer.userCommentModelData,
});

export default connect(mapStateToProps, { onLeave, openAddTaskModal, openTaskDetailModel })(AppTaskbar);
